import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { stableQueryKey } from '@neptune/shared/common-util';
import { ProjectWithRole } from '@neptune/shared/core-project-domain';
import { getProjectsDetails } from '@neptune/shared/project-domain';

const EMPTY_MAP = new Map<string, ProjectWithRole>();

type UserQueryResultWithData<T> = Omit<UseQueryResult<T>, 'data'> & { data: T };

export function useProjectsDetailsMap(
  ids: string[],
): UserQueryResultWithData<Map<string, ProjectWithRole>> {
  const { data = EMPTY_MAP, ...rest } = useQuery({
    retry: false,
    select: selectProjectDetailsMap,
    suspense: true,
    keepPreviousData: true,
    placeholderData: [],
    staleTime: 5_000,
    queryKey: stableQueryKey('projects-details', ids),
    queryFn: async () => getProjectsDetails(ids),
  });

  return { data, ...rest };
}

const selectProjectDetailsMap = (projects: ProjectWithRole[]): Map<string, ProjectWithRole> => {
  return projects.reduce(
    (acc, project) => (acc.set(project.id, project), acc),
    new Map<string, ProjectWithRole>(),
  );
};
